module.exports = __webpack_public_path__ + "img/39_65.47df34bc.png";